import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import tblLieferanten, { TblLieferanten, Value } from '../model/tblLieferanten';
import { CompanyWrGruppenResult } from '@/shared/model/company';
import {
  LieferantenFacetSearchData,
  LieferantenSearchData,
} from '@/shared/model/smallPayloadModels/lieferantenSearchData';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '@/shared/utils/Constants';
//import tblKollegenauslieferung, { TblKollegenauslieferung, Value1 } from '../model/tblKollegenauslieferung';
const searchableColumns: Map<string, string> = new Map([
  ['MemberzrNumber', 'zr_number'],
  ['GsName', 'gs_name'],
  ['ZipCircle', 'zip_circle'],
  ['DeliverAbroadCountry', 'deliver_abroad_country'],
  ['DeliverIslandName', 'deliver_island_name'],
  ['DeliveryColleagueContact', 'delivery_colleague_contact'],
  ['DeliveryColleagueEmail', 'delivery_colleague_email'],
  ['DeliveryColleaguePhone', 'delivery_colleague_phone'],
  ['DeliveryColleagueProductgroup', 'delivery_colleague_productgroup'],
  ['DeliveryColleagueCondition', 'delivery_colleague_condition'],
]);
const defaultOrSearchFields = [
  'name',
  'status',
  'unternehmensnameZUSATZ',
  'suchname2',
  'zrBemerkungenzuKreditor_EXTERN',
  'strasse',
  'plz',
  'ort',
  'land',
  'telefon',
  'eMailAdresse',
  'uStIdNrn',
  "cast(zrBeginn,'Edm.String')",
  "cast(zrEnde,'Edm.String')",
  'plzGebiet',
  'webseite',
];

export interface BackendTblLieferanten {
  getLieferanteng: (searchParams: SearchParams, searchData?: any) => AxiosPromise<Value>;
  getLieferantenFacetSearch: (facetSearch: LieferantenFacetSearchData) => AxiosPromise<Value>;
  getZrNumberList(lieferantenSearchData: any): AxiosPromise<any>;
  getStatusCompaniesList(lieferantenSearchData: any): AxiosPromise<any>;
  getHauptwarengruppenList(lieferantenSearchData: any): AxiosPromise<CompanyWrGruppenResult[]>;
  outputLieferantengData: (searchParams: SearchParams, searchData?: any) => AxiosPromise<Value>;
  getLieferantengDataReport(searchData?: any): AxiosPromise<any>;
  getLieferantenExcelReport: (searchData?: any) => AxiosPromise<Value>;
  createLieferantenFileLogRecord(data: any): AxiosPromise<any>;
}

export const defaultBackendTblLieferanten: BackendTblLieferanten = {
  getZrNumberList(lieferantenSearchData?: any): AxiosPromise<any> {
    return instance.post<any>(`${URLS.tblLieferanten}/GetZrNumberList`, lieferantenSearchData);
  },
  getStatusCompaniesList(lieferantenSearchData?: any): AxiosPromise<any> {
    return instance.post<any>(`${URLS.tblLieferanten}/GetStatusCompaniesList`, lieferantenSearchData);
  },
  getHauptwarengruppenList(lieferantenSearchData?: any): AxiosPromise<CompanyWrGruppenResult[]> {
    return instance.post<CompanyWrGruppenResult[]>(
      `${URLS.tblLieferanten}/GetHauptwarengruppenList`,
      lieferantenSearchData
    );
  },
  getLieferanteng(searchParams: any, searchData?: any): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    if (searchParams.andClauseFieldsIds?.length > 0) {
      if (!searchParams.andClauseFieldsIds?.some((x: any) => x.chipField == 'all')) {
        searchParams.orClauseFieldsIds = [];
      } else {
        let allChipField = searchParams.andClauseFieldsIds?.find((x: any) => x.chipField == 'all');
        searchParams.filter = allChipField.searchWord;
        searchParams.orClauseFieldsIds = defaultOrSearchFields;
      }
      let andClauseFieldsIds: Array<any> = searchParams.andClauseFieldsIds;

      andClauseFieldsIds.forEach((element: any, index: number) => {
        const chipField = searchableColumns.has(element.chipField)
          ? searchableColumns.get(element.chipField)
          : element.chipField;
        if (element.chipField == 'all') {
          // do nothing
        } else if (chipField != 'zip_circle') {
          odfb.contains(`tolower(${chipField})`, element.searchWord.toLowerCase());
          //odfb.startsWith(`tolower(${chipField})`, element.searchWord.toLowerCase());
        }
        //  else {
        //   odfb.contains(`tolower(${chipField})`, element.searchWord.toLowerCase());
        // }
      });
    }

    let url = DefaultBackendHelper.makeUrl(
      `${URLS.tblLieferantenOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );
    if (url.toString().includes('contains(tolower(ZrEnde)')) {
      url = url.replaceAll('contains(tolower(ZrEnde),', "contains(tolower(cast(ZrEnde, 'Edm.String')),");
    }
    if (url.toString().includes('contains(tolower(ZrBeginn)')) {
      url = url.replaceAll('contains(tolower(ZrBeginn),', "contains(tolower(cast(ZrBeginn, 'Edm.String')),");
    }

    if (url.toString().includes('konditionen')) {
      url = url.replaceAll('konditionen', 'isKonditionen');
    }

    return instance.put<Value>(url, searchData);
  },
  getLieferantenFacetSearch(facetData: LieferantenFacetSearchData): AxiosPromise<any> {
    let url = `${URLS.tblLieferanten}/GetSearchResult`;
    return instance.put<Value>(url, facetData);
  },
  outputLieferantengData(searchParams: any, searchData?: any): AxiosPromise<Value> {
    return instance.put<any>(`${URLS.tblLieferanten}/OutputLieferantengData`, searchData);
  },
  getLieferantengDataReport(searchData?: any): AxiosPromise<any> {
    return instance.put<any>(`${URLS.tblLieferanten}/GetLieferantengDataReport`, searchData, {
      responseType: 'blob',
    });
  },
  getLieferantenExcelReport(searchData?: any): AxiosPromise<Value> {
    return instance.post<any>(`${URLS.tblLieferanten}/GetLieferantenExcelReport`, searchData, {
      responseType: 'blob',
    });
  },
  createLieferantenFileLogRecord(data: any): AxiosPromise<any> {
    return instance.post<any>(`${URLS.tblLieferanten}/CreateLieferantenFileLogRecord`, data);
  },
};
